module.exports = __webpack_public_path__ + "static/Appicon-90d47f3ac795c644fd83450527656d2c.png";